import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../components/auth/request/AuthProvider";
export default function PrivateRoute(){
  const { token } = useAuth();
  // If the session expires, redirect to the Login page/
  return token ? <Outlet /> : <Navigate to="/" />;
  //renderizado condicional
};


